export default "__VITE_ASSET__BVv47YI6__"